export default __webpack_public_path__ + "static/media/pic-login-primary.8cf0b1d4.png";